import { getRequest } from "../api/apiService";

/**
 * Generates a QR code for an asset by sending a GET request to the server.
 * 
 * This function sends a GET request to the server to generate a QR code for a specific asset
 * identified by its ID. If the request is successful, it logs the generated QR code and returns 
 * a success response along with the data. If an error occurs, it logs the error and returns a failure response.
 * 
 * @param {string} id - The ID of the asset for which to generate a QR code.
 * 
 * @returns {Promise<Object>} An object indicating the success or failure of the operation, along with the QR code data or error.
 */
export const generateAssetQRCode = async (id) => {
  try {
    // Send a GET request to generate the QR code for the asset
    const response = await getRequest(`/api/qrcode/generate/asset/${id}`);
    // Return success response with the generated QR code data
    return { success: true, data: response };
  } catch (error) {
    return { success: false, error };
  }
};

/**
 * Generates a QR code for a location by sending a GET request to the server.
 * 
 * This function sends a GET request to the server to generate a QR code for a specific location
 * identified by its ID. If the request is successful, it logs the generated QR code and returns 
 * a success response along with the data. If an error occurs, it logs the error and returns a failure response.
 * 
 * @param {string} id - The ID of the location for which to generate a QR code.
 * 
 * @returns {Promise<Object>} An object indicating the success or failure of the operation, along with the QR code data or error.
 */
export const generateLocationQRCode = async (id) => {
  try {
    // Send a GET request to generate the QR code for the location
    const response = await getRequest(`/api/qrcode/generate/location/${id}`);
    // Return success response with the generated QR code data
    return { success: true, data: response };
  } catch (error) {
    return { success: false, error };
  }
};